import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {Router} from '@angular/router';
import {RestService} from '../shared/rest/rest.service';
import {BehaviorSubject} from "rxjs";
import {IUrl} from "../logout-iframe/logout-iframe.component";
import {EnvironmentService} from "bos-commons";

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss']
})
export class LogoutComponent implements OnInit {

  public getUrls = new Set<IUrl>();

  public postUrls = new Set<IUrl>();

  private completedGetUrls = new Set<IUrl>();
  private completedPostUrls = new Set<IUrl>();

  @Output()
  public logoutCompleted = new EventEmitter<boolean>()

  constructor(public router: Router,
              public restService: RestService,
              public env: EnvironmentService) { }

  ngOnInit(): void {
    this.restService.getLogoutUrls().subscribe(value => {
      value.filter(v => v.useGet).forEach(v => this.getUrls.add(this.parse(v)));
      value.filter(v => !v.useGet).forEach(v => this.postUrls.add(this.parse(v)));
    })
  }

  addToCompletedGets(url: IUrl) {
    this.completedGetUrls.add(url);
    if(!this.allGetCompletedEmitter.getValue() && this.allGetCompleted()) {
      this.allGetCompletedEmitter.next(this.allGetCompleted());
    }
    if (this.canRefresh()) {
      this.refresh();
    }
  }


  addToCompletedPosts(url: any) {
    this.completedPostUrls.add(url);
    if (this.canRefresh()) {
      this.refresh();
    }
  }

  private canRefresh(): boolean {
    return this.allGetCompleted() && this.allPostCompleted();
  }

  private refresh() {
    this.logoutCompleted.emit(true)
  }

  public allGetCompletedEmitter = new BehaviorSubject(false);

  allGetCompleted() {
    return this.getUrls.size === this.completedGetUrls.size
  }


  allPostCompleted() {
    return this.postUrls.size === this.completedPostUrls.size
  }

  private parse(url: IUrl) {
    if(this.env.environment.relativeLogout) {
      const uri = new URL(url.logoutUrl);
      url.logoutUrl = uri.pathname + uri.search + uri.hash;
    }
    return url;
  }
}
